module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_burundi-16ae07c8.png";